var SupportedCodeFormats = /* @__PURE__ */ ((SupportedCodeFormats2) => {
  SupportedCodeFormats2[SupportedCodeFormats2["QR_CODE"] = 0] = "QR_CODE";
  SupportedCodeFormats2[SupportedCodeFormats2["AZTEC"] = 1] = "AZTEC";
  SupportedCodeFormats2[SupportedCodeFormats2["CODABAR"] = 2] = "CODABAR";
  SupportedCodeFormats2[SupportedCodeFormats2["CODE_39"] = 3] = "CODE_39";
  SupportedCodeFormats2[SupportedCodeFormats2["CODE_93"] = 4] = "CODE_93";
  SupportedCodeFormats2[SupportedCodeFormats2["CODE_128"] = 5] = "CODE_128";
  SupportedCodeFormats2[SupportedCodeFormats2["DATA_MATRIX"] = 6] = "DATA_MATRIX";
  SupportedCodeFormats2[SupportedCodeFormats2["MAXICODE"] = 7] = "MAXICODE";
  SupportedCodeFormats2[SupportedCodeFormats2["ITF"] = 8] = "ITF";
  SupportedCodeFormats2[SupportedCodeFormats2["EAN_13"] = 9] = "EAN_13";
  SupportedCodeFormats2[SupportedCodeFormats2["EAN_8"] = 10] = "EAN_8";
  SupportedCodeFormats2[SupportedCodeFormats2["PDF_417"] = 11] = "PDF_417";
  SupportedCodeFormats2[SupportedCodeFormats2["RSS_14"] = 12] = "RSS_14";
  SupportedCodeFormats2[SupportedCodeFormats2["RSS_EXPANDED"] = 13] = "RSS_EXPANDED";
  SupportedCodeFormats2[SupportedCodeFormats2["UPC_A"] = 14] = "UPC_A";
  SupportedCodeFormats2[SupportedCodeFormats2["UPC_E"] = 15] = "UPC_E";
  SupportedCodeFormats2[SupportedCodeFormats2["UPC_EAN_EXTENSION"] = 16] = "UPC_EAN_EXTENSION";
  return SupportedCodeFormats2;
})(SupportedCodeFormats || {});
export {
  SupportedCodeFormats
};
//# sourceMappingURL=types.js.map
